import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import cn from 'classnames';

import styles from './Header.module.postcss';

function MobileSubMenu({ children, active, onClose, id, title }) {
  return (
    <nav
      id={id}
      className={cn(styles.SubNav, {
        [styles.SubNav_active]: active,
      })}
      aria-hidden={!active}
    >
      <div className={styles.SubNav_Header}>
        <button
          type='button'
          className={cn(styles.HeaderMenuToggle, styles.SubNav_Back)}
          onClick={onClose}
          aria-label='Back'
        >
          <SVG src='/static/images/icons/material-ui-chevron-left.svg' alt='' height='20' width='20' />
        </button>
        { title && <span className={styles.SubNav_Title}>{title}</span> }
      </div>
      <div className={styles.SubNav_Content}>
        {children}
      </div>
    </nav>
  );
}

MobileSubMenu.propTypes = {
  id: PropTypes.string,
  active: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

export default MobileSubMenu;
